import { Observable, RequestType, startFetchProxy, startXhrProxy } from '@datadog/browser-core';
var nextRequestId = 1;
export function startRequestCollection() {
  var requestObservables = [new Observable(), new Observable()];
  trackXhr(requestObservables);
  trackFetch(requestObservables);
  return requestObservables;
}
export function trackXhr(_a) {
  var requestStartObservable = _a[0],
      requestCompleteObservable = _a[1];
  var xhrProxy = startXhrProxy();
  xhrProxy.beforeSend(function (context) {
    var requestId = getNextRequestId();
    context.requestId = requestId;
    requestStartObservable.notify({
      requestId: requestId
    });
  });
  xhrProxy.onRequestComplete(function (context) {
    requestCompleteObservable.notify({
      duration: context.duration,
      method: context.method,
      requestId: context.requestId,
      response: context.response,
      startTime: context.startTime,
      status: context.status,
      traceId: getTraceId(),
      type: RequestType.XHR,
      url: context.url
    });
  });
  return xhrProxy;
}
export function trackFetch(_a) {
  var requestStartObservable = _a[0],
      requestCompleteObservable = _a[1];
  var fetchProxy = startFetchProxy();
  fetchProxy.beforeSend(function (context) {
    var requestId = getNextRequestId();
    context.requestId = requestId;
    requestStartObservable.notify({
      requestId: requestId
    });
  });
  fetchProxy.onRequestComplete(function (context) {
    requestCompleteObservable.notify({
      duration: context.duration,
      method: context.method,
      requestId: context.requestId,
      response: context.response,
      responseType: context.responseType,
      startTime: context.startTime,
      status: context.status,
      traceId: getTraceId(),
      type: RequestType.FETCH,
      url: context.url
    });
  });
  return fetchProxy;
}

function getNextRequestId() {
  var result = nextRequestId;
  nextRequestId += 1;
  return result;
}
/**
 * Get the current traceId generated from dd-trace-js (if any).
 *
 * Note: in order to work, the browser-sdk should be initialized *before* dd-trace-js because both
 * libraries are wrapping fetch() and XHR.  Wrappers are called in reverse order, and the
 * dd-trace-js wrapper needs to be called first so it can generate the new trace.  The browser-sdk
 * wrapper will then pick up the new trace id via this function.
 */


function getTraceId() {
  // tslint:disable-next-line: no-unsafe-any
  return 'ddtrace' in window && window.ddtrace.tracer.scope().active() ? // tslint:disable-next-line: no-unsafe-any
  window.ddtrace.tracer.scope().active().context().toTraceId() : undefined;
}